import { AUTH_ROUTE_NAME } from "@/libs/route-name";

export const verifyEmailRoute = () => {
  return {
    name: AUTH_ROUTE_NAME.VERIFY_EMAIL,
    path: "verify-email",
    component: () => import("@/pages/auth/verify-email.vue")
  };
};
